import { render, staticRenderFns } from "./BarsByAge.vue?vue&type=template&id=15a086f2&scoped=true&"
import script from "./BarsByAge.vue?vue&type=script&lang=js&"
export * from "./BarsByAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a086f2",
  null
  
)

export default component.exports